module.exports = __webpack_public_path__ + "img/KinokoTable04.755616f0.jpg";